import React from 'react';
import clsx from 'clsx';
import styles from './DashboardHeader.module.css';

export interface DashboardHeaderProps {
  title: string;
  subtitle?: string;
  role?: string;
  lastUpdated?: string;
  className?: string;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ title, subtitle, role, lastUpdated, className }) => {
  return (
    <div className={clsx(styles.header, className)}>
      <div className={styles.welcomeSection}>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {(role || lastUpdated) && (
        <div className={styles.meta}>
          {role && <span className={styles.role}>{role}</span>}
          {lastUpdated && <span className={styles.lastUpdated}>{lastUpdated}</span>}
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
